// creates proxied object with default return value
export function createDefaultReturnProxy<T>(
  object: Record<string | symbol, T>,
  defaultValue: T
): Record<string | symbol, T> {
  return new Proxy(object, {
    get: (target, prop) => {
      if (prop in target) {
        return target[prop]
      } else {
        return defaultValue
      }
    },
  })
}
